"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../../utils/errorHandling");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function getQueryParams(payload) {
        const list = Object.entries(payload);
        if (list.length === 0) {
            return '';
        }
        return '?' + list.map(([key, val]) => `${key}=${val}`).join('&');
    }
    function fetch(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => {
            let route = `project/${action.payload.id}/members`;
            if (action.payload.type === 'SUBPROJECT') {
                route = `user-group/subproject/${action.payload.id}/group`;
            }
            if (action.payload.type === 'CUSTOMER_MEMBERS') {
                route = `customer/${action.payload.id}/members`;
            }
            else if (action.payload.type === 'CUSTOMER_USER_GROUPS') {
                route = `user-group/customer/${action.payload.id}/group`;
            }
            return ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'GET',
                url: `${baseUrl}api/${route}${getQueryParams(action.payload.params)}`
            }).pipe((0, operators_1.mergeMap)((xhr) => (0, rxjs_1.of)(t
                .array(t.interface({
                group: sok_types_1.UserGroup.iUserGroup,
                members: t.union([t.array(sok_types_1.User.iUser), t.undefined])
            }))
                .decode(xhr.response)
                .fold((e) => Actions.fetchFailed((0, errorHandling_1.parseValidationError)(e)), (res) => Actions.fetchSuccess(res.map((x) => (Object.assign(Object.assign({}, x), { members: x.members || [] }))))))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
        }));
    }
    return { fetch };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map